import styles from "../../Styles/Button.module.css";

const Button = ({ children, clicked, log = false, ...rest }) => {
  return (
    <button
      {...rest}
      className={`${log ? styles["button--log"] : styles.button}`}
      onClick={() => {
        if (typeof clicked !== "undefined") {
          clicked(children);
        }
      }}
    >
      {children}
    </button>
  );
};
export default Button;
